var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag-zone transition-all duration-300 ease-in-out py-1",class:{
    'is-drag-active': _vm.isDragging,
    'is-drag-over': _vm.isDragOver,
    'has-drop-target': _vm.hasDropTarget
  },on:{"dragover":function($event){$event.preventDefault();return _vm.handleDragOver.apply(null, arguments)},"dragleave":_vm.handleDragLeave,"drop":function($event){$event.preventDefault();return _vm.handleDrop.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }